"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var url_1 = __importDefault(require("./url"));
var scriptTag_1 = __importDefault(require("./scriptTag"));
var font_utils_1 = __importDefault(require("font-utils"));
function default_1(configurations, logger) {
    return {
        url: new url_1.default(),
        scriptTag: new scriptTag_1.default(configurations, logger),
        fonts: font_utils_1.default
    };
}
exports.default = default_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi91dGlscy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUVBLDhDQUF1QjtBQUN2QiwwREFBbUM7QUFDbkMsMERBQXlDO0FBUXpDLG1CQUF5QixjQUFtQyxFQUFFLE1BQWM7SUFDeEUsT0FBTztRQUNILEdBQUcsRUFBRSxJQUFJLGFBQUcsRUFBRTtRQUNkLFNBQVMsRUFBRSxJQUFJLG1CQUFTLENBQUMsY0FBYyxFQUFFLE1BQU0sQ0FBQztRQUNoRCxLQUFLLEVBQUUsb0JBQUs7S0FDZixDQUFBO0FBQ0wsQ0FBQztBQU5ELDRCQU1DIn0=